export enum FeaturesEnum {
    Accounting = 'accounting',
    AiAgent = 'ai_agent',
    Analytical = 'analytical',
    ApiKey = 'api_key',
    AutoBanking = 'auto_banking',
    Banking = 'banking',
    BankMatching = 'bank_matching',
    CardReceipts = 'card_receipts',
    CashManagement = 'cash_management',
    Cheques = 'cheques',
    CreditCardTransactions = 'credit_card_transactions',
    Dashboard = 'dashboard',
    EmailCollection = 'email_collection',
    Expenses = 'expenses',
    InvoiceAutoAllocation = 'invoice_auto_allocation',
    Loans = 'loans',
    Messaging = 'messaging',
    Ocr = 'ocr',
    ProductCategories = 'product_categories',
    PurchaseInvoices = 'purchase_invoices',
    PurchasePayments = 'purchase_payments',
    RecurringInvoices = 'recurring_invoices',
    Remunerations = 'remunerations',
    SalesEmails = 'sales_emails',
    SalesEmailsNoLogo = 'sales_emails_no_logo',
    SalesInvoices = 'sales_invoices',
    SalesPayments = 'sales_payments',
    SalesQuotations = 'sales_quotations',
    Subsidies = 'subsidies',
    Tgc = 'tgc',
    WidgetBank = 'widget_bank',
    WidgetCharges = 'widget_charges',
    WidgetPurchaseInvoices = 'widget_purchase_invoices',
    WidgetSalesInvoices = 'widget_sales_invoices',
    WidgetWatchList = 'widget_watchlist',
}